import { getToken } from '@/utils/auth'
import { getStore } from '@/utils/store'

const state = {
    userInfo: getStore({ name: 'userInfo' }) || null,
    permission: getStore({
        name: 'permission'
    }) || {},
    menu: getStore({
        name: 'menu'
    }) || [],
    menuAll: [],
    token: getToken() || '',
    isStudent: false,
    isTeacher: false,
    isAdmin: false,
    isDeptAdmin: false,
    loginUserDept: getStore({ name: 'loginUserDept' }) || {}
}

export default state
